import React, { FC } from 'react';
import {
    SkeletonBlock,
    SkeletonCanvasBlock,
    SkeletonFlexSpacer,
    SkeletonFullscreenContent,
    SkeletonFullscreenOverlay,
    SkeletonFullscreenTopBar,
    SkeletonRow
} from 'src/components/widgets/skeleton';

export const PlacementPageSkeleton: FC = () => (
    <SkeletonFullscreenOverlay aria-hidden='true'>
        <SkeletonFullscreenTopBar>
            <SkeletonBlock $width='36px' $height='36px' $round />
            <SkeletonBlock $width='min(220px, 42vw)' $height='22px' $radius='8px' />
            <SkeletonFlexSpacer />
            <SkeletonRow $gap='10px'>
                <SkeletonBlock $width='80px' $height='36px' $radius='6px' />
                <SkeletonBlock $width='36px' $height='36px' $round />
            </SkeletonRow>
        </SkeletonFullscreenTopBar>
        <SkeletonFullscreenContent>
            <SkeletonCanvasBlock $width='60%' $height='70%' $radius='8px' />
        </SkeletonFullscreenContent>
    </SkeletonFullscreenOverlay>
);
